var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((({
        disabled: _vm.disabled,
        type: _vm.type,
        placeholder: _vm.placeholder
    }).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.modelWrapper),expression:"modelWrapper"}],staticClass:"base-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.modelWrapper)?_vm._i(_vm.modelWrapper,null)>-1:(_vm.modelWrapper)},on:{"blur":_vm.onBlur,"change":function($event){var $$a=_vm.modelWrapper,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.modelWrapper=$$a.concat([$$v]))}else{$$i>-1&&(_vm.modelWrapper=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.modelWrapper=$$c}}}},'input',{
        disabled: _vm.disabled,
        type: _vm.type,
        placeholder: _vm.placeholder
    },false)):((({
        disabled: _vm.disabled,
        type: _vm.type,
        placeholder: _vm.placeholder
    }).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.modelWrapper),expression:"modelWrapper"}],staticClass:"base-input",attrs:{"type":"radio"},domProps:{"checked":_vm._q(_vm.modelWrapper,null)},on:{"blur":_vm.onBlur,"change":function($event){_vm.modelWrapper=null}}},'input',{
        disabled: _vm.disabled,
        type: _vm.type,
        placeholder: _vm.placeholder
    },false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.modelWrapper),expression:"modelWrapper"}],staticClass:"base-input",attrs:{"type":({
        disabled: _vm.disabled,
        type: _vm.type,
        placeholder: _vm.placeholder
    }).type},domProps:{"value":(_vm.modelWrapper)},on:{"blur":_vm.onBlur,"input":function($event){if($event.target.composing){ return; }_vm.modelWrapper=$event.target.value}}},'input',{
        disabled: _vm.disabled,
        type: _vm.type,
        placeholder: _vm.placeholder
    },false))}
var staticRenderFns = []

export { render, staticRenderFns }